
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface WeekNavigationProps {
  startOfCurrentWeek: Date;
  weekOffset: number;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
}

export const WeekNavigation = ({ 
  startOfCurrentWeek, 
  weekOffset, 
  onPreviousWeek, 
  onNextWeek 
}: WeekNavigationProps) => {
  return (
    <div className="flex justify-center items-center gap-2">
      <Button 
        variant="ghost" 
        size="icon"
        onClick={onPreviousWeek}
        className="hover:bg-clubbers-light-blue/5"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="text-sm text-muted-foreground">
        {format(startOfCurrentWeek, 'MMM d', { locale: es })} - {format(addDays(startOfCurrentWeek, 6), 'MMM d', { locale: es })}
      </span>
      <Button 
        variant="ghost" 
        size="icon"
        onClick={onNextWeek}
        disabled={weekOffset === 0}
        className="hover:bg-clubbers-light-blue/5 "
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};
